import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  Box,
  Avatar,
  Typography,
  IconButton,
  DialogContent,
  CardMedia,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { UseLandingsPages } from "./UseLandingsPages";
import { rsParentCom, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { useNavigate, useLocation } from "react-router-dom";

export default function LandingPageAllContents(props) {
  const location = useLocation();
  const { GetLandingAllComponents } = UseLandingsPages();
  const [components, setComponents] = useState();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [msParentCom, setMsParentCom] = useRecoilState(rsParentCom);

  useEffect(() => {
    setProgress(true);
    GetLandingAllComponents((model) => {
      setComponents(model);
    });
  }, []);

  return (
    <Dialog
      sx={{ "& .MuiDialog-paper": { borderRadius: 5 } }}
      fullWidth={true}
      maxWidth="md"
      onClose={() => props.setOpenDialog(false)}
      open={props.openDialog}
    >
      <DialogTitle
        sx={{ display: "flex", justifyContent: "space-between", pb: 1 }}
      >
        <Typography>آیتم خود را انتخاب کنید</Typography>
        <IconButton onClick={() => props.setOpenDialog(false)}>
          <ClearIcon fontSize="small" sx={{ fill: "#8e8e8e" }} />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mx: 2, mb: 1, maxHeight: 400, overflow: "auto" }}>
          {components &&
            components.map((model) => {
              return (
                <Box
                  sx={{ display: "flex", flexDirection: "column", mb: 2 }}
                  key={model.id}
                >
                  <Typography>{model.title}</Typography>
                  <Box
                    display="grid"
                    gridTemplateColumns="repeat(12, 1fr)"
                    gap={1}
                  >
                    {model.components &&
                      model.components.map((m) => {
                        return (
                          <Box
                            key={m.id}
                            gridColumn="span 6"
                            sx={{
                              border: "1px solid #DCDCE4",
                              p: 2,
                              borderRadius: 2,
                              display: "flex",
                              justifyContent: "space-between",
                              "&:hover": {
                                cursor: "pointer",
                              },
                            }}
                          >
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <Box sx={{ mr: 2 }}>
                                <CardMedia
                                  sx={{
                                    width: "40px",
                                  }}
                                  component="img"
                                  image={m.icon}
                                />
                              </Box>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <Typography variant="subtitle2">
                                  {m.faTitle}
                                </Typography>
                                <Typography variant="caption">
                                  {m.description}
                                </Typography>
                              </Box>
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "flex-end",
                              }}
                              onClick={() => {
                                let tempRow = props.row && props.row.slice();
                                var lastRowIndex = Math.max.apply(
                                  Math,
                                  props.row.map(function (o) {
                                    return o.rowIndex + 1;
                                  })
                                );
                                let newmodel = {
                                  landingId:
                                    msParentCom?.landingPageID &&
                                    msParentCom.landingPageID,
                                  componentID: m.id,
                                  rowIndex:
                                    lastRowIndex != -Infinity
                                      ? lastRowIndex
                                      : 1,
                                  isActive: false,
                                  image: m.image,
                                };
                                tempRow.push(newmodel);
                                props.callback(tempRow);
                                props.setOpenDialog(false);
                              }}
                            >
                              <IconButton>
                                <AddCircleIcon color="secondary" />
                              </IconButton>
                            </Box>
                          </Box>
                        );
                      })}
                  </Box>
                </Box>
              );
            })}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
